import { getProvider, getWeb3, waitForConfirmation } from ".";
import config from "../../config/config";

import MafiaHelperBotAbi from "../../abis/MafiaHelperBot.json";
import { HelperBotInfo } from "../../types/Contract/HelperBot/HelperBotInfo";
import { HelperSmuggleBotInfo } from "../../types/Contract/HelperBot/HelperSmuggleBotInfo";
import {
  parseBulletBotPlusInfo,
  parseHelperBotInfo,
  parseHelperSmuggleBotInfo,
} from "../game";
import { BulletBotPlusInfo } from "../../types/Contract/HelperBot/BulletBotPlusInfo";

export const getMafiaHelperBotContract = (provider = false) => {
  const web3 = provider ? getProvider() : getWeb3();
  const contractAddress = config.helperBotAddress;
  const MafiaHelperBotContract = new web3.eth.Contract(
    MafiaHelperBotAbi,
    contractAddress
  );
  return MafiaHelperBotContract;
};

export const startCrimeBot = async (account: string, attemptCount: number) => {
  const MafiaHelperBotContract = getMafiaHelperBotContract(true);
  const txData = await MafiaHelperBotContract.methods
    .startCrimeBot(attemptCount)
    .send({ from: account });

  await waitForConfirmation(txData.transactionHash);

  return txData;
};

export const endCrimeBot = async (account: string) => {
  const MafiaHelperBotContract = getMafiaHelperBotContract(true);
  const txData = await MafiaHelperBotContract.methods
    .endCrimeBot()
    .send({ from: account });

  await waitForConfirmation(txData.transactionHash);

  return txData;
};

export const startCarBot = async (account: string, attemptCount: number) => {
  const MafiaHelperBotContract = getMafiaHelperBotContract(true);
  const txData = await MafiaHelperBotContract.methods
    .startCarBot(attemptCount)
    .send({ from: account });
  await waitForConfirmation(txData.transactionHash);
  return txData;
};

export const endCarBot = async (
  account: string,
  signMsg: string,
  signature: string
) => {
  const MafiaHelperBotContract = getMafiaHelperBotContract(true);
  const txData = await MafiaHelperBotContract.methods
    .endCarBot(JSON.stringify(signMsg), signature)
    .send({ from: account });

  console.log("Transaction successful:", txData.transactionHash);

  await waitForConfirmation(txData.transactionHash);
  return txData;
};

export const startKSBot = async (account: string, attemptCount: number) => {
  const MafiaHelperBotContract = getMafiaHelperBotContract(true);
  const txData = await MafiaHelperBotContract.methods
    .startKSBot(attemptCount)
    .send({ from: account });

  await waitForConfirmation(txData.transactionHash);

  return txData;
};

export const endKSBot = async (account: string) => {
  const MafiaHelperBotContract = getMafiaHelperBotContract(true);
  const txData = await MafiaHelperBotContract.methods
    .endKSBot()
    .send({ from: account });
  await waitForConfirmation(txData.transactionHash);

  return txData;
};

export const startBoozeBot = async (account: string, attemptCount: number) => {
  const MafiaHelperBotContract = getMafiaHelperBotContract(true);
  const txData = await MafiaHelperBotContract.methods
    .startBoozeBot(attemptCount)
    .send({ from: account });
  await waitForConfirmation(txData.transactionHash);
  return txData;
};

export const endBoozeBot = async (
  account: string,
  signMsg: string,
  signature: string
) => {
  const MafiaHelperBotContract = getMafiaHelperBotContract(true);
  const txData = await MafiaHelperBotContract.methods
    .endBoozeBot(JSON.stringify(signMsg), signature)
    .send({ from: account });
  await waitForConfirmation(txData.transactionHash);
  return txData;
};

export const startNarcsBot = async (account: string, attemptCount: number) => {
  const MafiaHelperBotContract = getMafiaHelperBotContract(true);
  const txData = await MafiaHelperBotContract.methods
    .startNarcsBot(attemptCount)
    .send({ from: account });
  await waitForConfirmation(txData.transactionHash);
  return txData;
};

export const endNarcsBot = async (
  account: string,
  signMsg: string,
  signature: string
) => {
  const MafiaHelperBotContract = getMafiaHelperBotContract(true);
  const txData = await MafiaHelperBotContract.methods
    .endNarcsBot(JSON.stringify(signMsg), signature)
    .send({ from: account });
  await waitForConfirmation(txData.transactionHash);
  return txData;
};

export const startBulletBot = async (account: string, attemptCount: number) => {
  const MafiaHelperBotContract = getMafiaHelperBotContract(true);
  const txData = await MafiaHelperBotContract.methods
    .startBulletBot(attemptCount)
    .send({ from: account });
  await waitForConfirmation(txData.transactionHash);
  return txData;
};

export const endBulletBot = async (
  isAccepting: boolean,
  account: string,
  signMsg: string,
  signature: string
) => {
  const MafiaHelperBotContract = getMafiaHelperBotContract(true);
  const txData = await MafiaHelperBotContract.methods
    .endBulletBot(isAccepting, JSON.stringify(signMsg), signature)
    .send({ from: account });
  await waitForConfirmation(txData.transactionHash);
  return txData;
};

export const getUserCrimeBotInfo = async (account: string) => {
  const MafiaHelperBotContract = getMafiaHelperBotContract();
  const data: any = await MafiaHelperBotContract.methods
    .userCrimeBotInfo(account)
    .call({ from: account });
  return parseHelperBotInfo(data) as HelperBotInfo;
};

export const getUserCarBotInfo = async (account: string) => {
  const MafiaHelperBotContract = getMafiaHelperBotContract();
  const data = await MafiaHelperBotContract.methods
    .userCarBotInfo(account)
    .call({ from: account });
  return parseHelperBotInfo(data) as HelperBotInfo;
};

export const getUserKSBotInfo = async (account: string) => {
  const MafiaHelperBotContract = getMafiaHelperBotContract();
  const data = await MafiaHelperBotContract.methods
    .userKSBotInfo(account)
    .call({ from: account });
  return parseHelperBotInfo(data) as HelperBotInfo;
};

export const getUserBoozeBotInfo = async (account: string) => {
  const MafiaHelperBotContract = getMafiaHelperBotContract();
  const data = await MafiaHelperBotContract.methods
    .userBoozeBotInfo(account)
    .call({ from: account });
  return parseHelperSmuggleBotInfo(data) as HelperSmuggleBotInfo;
};

export const getUserNarcsBotInfo = async (account: string) => {
  const MafiaHelperBotContract = getMafiaHelperBotContract();
  const data = await MafiaHelperBotContract.methods
    .userNarcsBotInfo(account)
    .call({ from: account });
  return parseHelperSmuggleBotInfo(data) as HelperSmuggleBotInfo;
};

export const getUserBulletBotInfo = async (account: string) => {
  const MafiaHelperBotContract = getMafiaHelperBotContract();
  const data = await MafiaHelperBotContract.methods
    .userBulletBotInfo(account)
    .call({ from: account });
  return parseHelperBotInfo(data) as HelperBotInfo;
};

export const getUserBulletBotPlusInfo = async (account: string) => {
  const MafiaHelperBotContract = getMafiaHelperBotContract();
  const data = await MafiaHelperBotContract.methods
    .userBulletBotPlusInfo(account)
    .call({ from: account });
  return parseBulletBotPlusInfo(data) as BulletBotPlusInfo;
};
